function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M646.4 358.4a248.746667 248.746667 0 0 0-249.6 248.32v250.88a38.4 38.4 0 0 0 38.4 38.4h89.6a38.4 38.4 0 0 0 38.4-38.4v-250.88a82.773333 82.773333 0 0 1 91.733333-82.346667 85.333333 85.333333 0 0 1 74.666667 85.333334v247.893333a38.4 38.4 0 0 0 38.4 38.4h89.6a38.4 38.4 0 0 0 38.4-38.4v-250.88a248.746667 248.746667 0 0 0-249.6-248.32z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M128 396.8m38.4 0l115.2 0q38.4 0 38.4 38.4l0 422.4q0 38.4-38.4 38.4l-115.2 0q-38.4 0-38.4-38.4l0-422.4q0-38.4 38.4-38.4Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M224 224m-96 0a96 96 0 1 0 192 0 96 96 0 1 0-192 0Z"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.27a1d17c.svg";
export { ForwardRef as ReactComponent };